import { setting } from './setting';
// import _ from "lodash";
import { types } from './types';
import axios from 'axios';
// import * as set from 'lodash.set';
import * as merge from 'lodash.merge';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const calculateCartSum = function (cart) {
  let sum = cart.donations || 0;
  let tickets = cart.tickets;
  let bar = cart.bar;
  if (tickets) {
    for (let ticket of tickets) {
      sum += Number(ticket.price);
    }
  }

  if (bar) {
    for (let barItem of bar) {
      sum += Number(barItem.price) * Number(barItem.count);
    }
  }

  return sum;
};

export default new Vuex.Store({
  state: {
    idToken: null,
    widget_theatre_id: null,
    customer: {
      accounts: {},
      accountsList: [],
    },
    user: {
      sessionEndAt: null,
      sessionId: null,
      socketSessionId: null,
      ticketOrderId: null,
      barOrderId: null,
      barOrderCode: null,
      transactionId: null,
      card: {
        number: null,
        balance: null,
        id: null,
      },
      maxBonuses: 0,
      email: null,
      name: null,
      phone: '',
      prepareOrderBefore: null,
      subscription: false,
      paymentType: 'online',
      paymentWithBonuses: false, // Включена ли оплата бонусами (задается пользователем на странице оплаты)
      isAuthorized: false,
      isRegistrationInWidget: false,
    },
    session: {
      DateTime: '',
    },
    theatre: {
      NameFull: '',
    },
    places: [],
    rows: [],
    movie: {
      Genres: [],
    },
    bar: [],
    cart: {
      tickets: [],
      bar: [],
      ticketSum: 0, // промежуточная стоимость всех билетов
      barSum: 0, // промежуточная стоимость всей продукции бара
      sum: 0, // сумма с учетом бонусов. Отправляется в платежную систему
      totalSum: 0, // общая сумма без учета бонусов
      usedBonuses: 0, // общее количество бонусов. Находится в сторе, чтоб восстановить значение после смена route
      spentBonuses: {
        bar: 0, // количество потраченных бонусов на бар
        tickets: 0, // количество потраченных бонусов на билеты
      },
      donations: '',
    },
    setting: {
      notification1Show: false,
      notification1Title: '',
      notification1Descr: '',
      notification1Only3d: false,
      notification1Image: '',
      notification2Show: false,
      notification2Title: '',
      notification2Descr: '',
      notification2Only3d: false,
      notification2Image: '',
      notification3Show: false,
      notification3Title: '',
      notification3Descr: '',
      notification3Only3d: false,
      notification3Image: '',
      currency: '₽',
      supportPhone: null,
      maxSeats: null,
      isBonusAvailable: false, // есть ли возможность оплаты бонусами. (Если есть апи ключ в админке)
      freePlaces: true,
      freeCostPlaces: true,
    },
    loading: true,
    errors: [],
    domain: '',
  },

  getters: {
    getAccountById: (state) => (id) => state.customer.accounts[id],

    maxAvailableDiscountToAccount: (state, getters) => (accountId) => {
      const account = getters.getAccountById(accountId);
      const maxBalance = Math.floor(account.balance);

      let maxBar = state.cart.barSum - 1;
      if (maxBar < 0) {
        maxBar = 0;
      }

      let maxTickets = state.cart.ticketSum - 1;
      if (maxTickets < 0) {
        maxTickets = 0;
      }

      getters.selectedCustomerAccounts.forEach((account) => {
        if (account.id !== accountId) {
          maxBar -= account.bar;
          maxTickets -= account.tickets;
        }
      });

      let all = maxTickets + maxBar;
      let bar;

      if (all > maxBalance) {
        all = maxBalance;
      }

      let tickets = Math.ceil(all / 2);

      if (tickets >= maxTickets) {
        tickets = maxTickets;
      }

      bar = all - tickets;

      if (bar > maxBar) {
        let diff = bar - maxBar;
        tickets += diff;
        bar = maxBar;
      }

      return {
        bar,
        tickets,
        all,
      };
    },

    selectedCustomerAccounts(state) {
      let accounts = [];
      state.customer.accountsList.forEach((accountId) => {
        const account = state.customer.accounts[accountId];
        if (account.selected) {
          accounts.push(account);
        }
      });

      return accounts;
    },

    // Получение бонусного аккаунта для начисления бонусов на случай, если покупка проходит без списани бонусов
    // P.S. надеюсь отработает без ошибок. из-за обращения к systemType может...
    bonusCustomerAccount(state) {
      let accounts = [];
      state.customer.accountsList.forEach((accountId) => {
        const account = state.customer.accounts[accountId];

        if (account.type.systemType === 'Bonuses') {
          accounts.push(account);
        }
      });
      return accounts;
    },

    usedDiscounts(state) {
      let tickets = 0;
      let bar = 0;

      state.customer.accountsList.forEach((accountId) => {
        const account = state.customer.accounts[accountId];
        if (account.selected) {
          tickets += account.tickets;
          bar += account.bar;
        }
      });

      return {
        tickets,
        bar,
        all: tickets + bar,
      };
    },

    total(state, getters) {
      let bar = state.cart.barSum;
      let tickets = state.cart.ticketSum;
      let discount = { bar: 0, tickets: 0, all: 0 };

      getters.selectedCustomerAccounts.forEach((account) => {
        bar -= account.discount.bar;
        tickets -= account.discount.tickets;
        discount.bar += account.discount.bar;
        discount.tickets += account.discount.tickets;
      });

      discount.all = discount.bar + discount.tickets;

      return {
        discount,
        bar,
        tickets,
        all: bar + tickets,
      };
    },
  },

  mutations: {
    [types.SET_DOMAIN](state, payload) {
      state.domain = payload;
    },
    [types.SET_LOADING](state, loading) {
      state.loading = loading;
    },
    // if product does not exist in cart then add else remove
    [types.ADD_PLACE_TO_CART](state, data) {
      state.cart.tickets.push(data.place);
      state.cart.sum += data.place.price;
      state.cart.ticketSum += data.place.price;
    },

    [types.REMOVE_PLACE_FROM_CART](state, index) {
      state.cart.sum -= state.cart.tickets[index].price;
      state.cart.ticketSum -= state.cart.tickets[index].price;
      state.cart.tickets.splice(index, 1);
    },

    // if product does not exist in cart then add else remove
    [types.ADD_BAR_TO_CART](state, data) {
      data.item.count = 1;
      state.cart.bar.push(data.item);
      state.cart.sum = Number(state.cart.sum) + Number(data.item.price);
      state.cart.barSum = Number(state.cart.barSum) + Number(data.item.price);
    },

    [types.SET_DONATION_SIZE](state, payload) {
      state.cart.sum =
        Number(state.cart.sum) - Number(state.cart.donations) + Number(payload);
      state.cart.donations = Number(payload);
    },

    [types.CHANGE_BAR_IN_CART](state, data) {
      state.cart.sum += state.cart.bar[data.index].price * data.count;
      state.cart.barSum += state.cart.bar[data.index].price * data.count;
      state.cart.bar[data.index].count += data.count;
    },

    [types.REMOVE_BAR_FROM_CART](state, index) {
      state.cart.sum -= state.cart.bar[index].price;
      state.cart.barSum -= state.cart.bar[index].price;
      state.cart.bar[index].count = 0;
      state.cart.bar.splice(index, 1);
    },

    [types.CLEAR_BAR](state) {
      state.cart.sum -= state.cart.barSum;
      state.cart.barSum = 0;
      state.cart.bar = [];
      state.bar = state.bar.map((barGroup) => {
        const items = Array.isArray(barGroup.items)
          ? barGroup.items
          : Object.entries(barGroup.items).map(([key, value]) => value);

        return {
          ...barGroup,
          items: items.map((item) => ({ ...item, count: 0 })),
        };
      });
    },

    [types.ADD_ERROR](state, error) {
      state.errors.push(error);
    },

    // TODO Разобраться в необходимости этой мутации
    [types.RESET_SESSION_END_AT](state) {
      state.user.sessionEndAt = null;
    },

    [types.CLEAR_CART](state) {
      state.cart = {
        tickets: [],
        bar: [],
        ticketSum: 0, // промежуточная стоимость всех билетов
        barSum: 0, // промежуточная стоимость всей продукции бара
        sum: 0, // сумма с учетом бонусов. Отправляется в платежную систему
        totalSum: 0, // общая сумма без учета бонусов
        usedBonuses: 0, // общее количество бонусов. Находится в сторе, чтоб восстановить значение после смена route
        spentBonuses: {
          bar: 0, // количество потраченных бонусов на бар
          tickets: 0, // количество потраченных бонусов на билеты
        },
      };
    },

    [types.CLEAR_USER](state) {
      state.user = {
        sessionEndAt: null,
        sessionId: null,
        socketSessionId: null,
        ticketOrderId: null,
        barOrderId: null,
        barOrderCode: null,
        transactionId: null,
        card: {
          number: null,
          balance: null,
          id: null,
        },
        maxBonuses: 0,
        email: null,
        name: null,
        prepareOrderBefore: null,
        subscription: false,
        paymentType: 'online',
        paymentWithBonuses: false, // Включена ли оплата бонусами (задается пользователем на странице оплаты)
        isAuthorized: false,
        createdAt: null,
        birthday: null,
        gender: null,
        phone: null,
      };
    },

    [types.CLEAR_ERRORS](state, delay = 0) {
      if (delay > 0) {
        setTimeout(() => {
          state.errors = [];
        }, delay);
      } else {
        state.errors = [];
      }
    },

    //tmp... create action for reserving
    [types.SET_TICKET_ORDER_ID](state, data) {
      state.user.ticketOrderId = data.ticketOrderId;

      if (data.userSessionEndAt) {
        let date = new Date();
        date.setTime(data.userSessionEndAt * 1000);
        state.user.sessionEndAt = date.toString();
      }
    },

    //tmp...
    [types.SET_LOCAL_ORDER_ID](state, data) {
      state.user.orderId = data.orderId;
    },

    //tmp...
    [types.SET_BAR_ORDER_ID](state, data) {
      state.user.barOrderId = data.barOrderId;
      state.user.barOrderCode = data.barOrderCode;
    },

    [types.SET_TRANSACTION_ID](state, data) {
      state.user.transactionId = data.transactionId;
    },

    [types.SET_DATA](state, data) {
      (state.session = {
        ...data.session,
        // NoSeats: true
        // IsEvent: true,
      }),
        // state.session = {
        //   ...data.session,
        //   Prices: data.session.Prices.map(price => ({ ...price, Sum: 0 })),
        // };
        (state.theatre = data.theatre);
      state.movie = data.movie;
      state.bar = data.bar;
      state.setting = {
        // donationShow: true,
        // donationTitle: '',
        // donationDescr: '',
        // donationMoney: '50 100 500 5000',

        // donationEventShow: true,
        // donationEventTitle: '<h1>Поддержать культурную программу</h1>',
        // donationEventDescr:
        //   '<p>Благотворительность — оказание помощи (безвозмездной или на льготных условиях) тем, кто в ней нуждается. Основной чертой благотворительности является добровольный выбор вида, времени и места, а также содержания (целевой) помощи. </p> <p>Согласно большому числу научных исследований, основные причины благотворительности состоят в том, что </p> <ul><li>- Люди по природе своей альтруистичны, ими движет желание помочь другим.</li><li>- Люди чувствуют себя лучше, когда жертвуют деньги. Экономисты называют это «теплотой альтруизма». </li> </ul> <p> К побудительным причинам благотворительности относится осознание её участниками целостности человеческого общества, более общее — всего живого на Земле, сопричастности и соответственности за мир, в котором мы живём. </p>',
        // donationEventMoney: '50 500 5000',
        // donationEventImage: 'https://premierzal.ru/img/photos/54669.jpg',
        freePlaces: true,
        freeCostPlaces: true,
        ...data.setting,
      };

      // state.setting.session.NoSeats = true;

      state.user.sessionId = data.user_session_id;
      state.widget_theatre_id = data.widget_theatre_id;

      if (!state.movie.MovieImageUrl) {
        state.movie.MovieImageUrl = '/movie-placeholder.png';
      }
    },

    //tmp get sessionData
    [types.SET_PLACES](state, data) {
      state.places = data.places;
      state.rows = data.rows;
    },

    // set payment type from buy page
    [types.SET_PAYMENT_TYPE](state, data) {
      state.user.paymentType.push = data;
    },

    [types.GET_TOTAL_SUM](state) {
      state.totalSum = calculateCartSum(state.cart);
    },

    [types.CHANGE_PAYMENT_WITH_BONUSES](state, { force, bonuses }) {
      let totalSum = calculateCartSum(state.cart);

      let barBonuses = 0,
        ticketBonuses = 0,
        paymentWithBonuses = force ? true : !state.user.paymentWithBonuses;

      let diff = totalSum - bonuses;
      if (paymentWithBonuses) {
        if (diff < 0) {
          barBonuses = state.cart.bar.length
            ? state.cart.barSum - 1
            : state.cart.barSum;
          ticketBonuses = state.cart.tickets.length
            ? state.cart.ticketSum - 1
            : state.cart.ticketSum;
        } else {
          if (state.cart.barSum < state.cart.ticketSum) {
            let minBonuses = state.cart.barSum
              ? Math.ceil((state.cart.barSum / totalSum) * bonuses)
              : 0;
            minBonuses =
              state.cart.barSum && state.cart.barSum - minBonuses === 0
                ? minBonuses - 1
                : minBonuses;
            barBonuses = minBonuses;
            ticketBonuses = bonuses - minBonuses;
          } else {
            let minBonuses = state.cart.ticketSum
              ? Math.ceil((state.cart.ticketSum / totalSum) * bonuses)
              : 0;
            minBonuses =
              state.cart.ticketSum && state.cart.ticketSum - minBonuses === 0
                ? minBonuses - 1
                : minBonuses;
            barBonuses = bonuses - minBonuses;
            ticketBonuses = minBonuses;
          }
        }
      } else {
        barBonuses = 0;
        ticketBonuses = 0;
      }

      state.cart.totalSum = totalSum;
      state.user.paymentWithBonuses = paymentWithBonuses;
      state.cart.spentBonuses.bar = barBonuses;
      state.cart.spentBonuses.tickets = ticketBonuses;
      state.cart.usedBonuses = barBonuses + ticketBonuses;
      state.cart.sum = totalSum - (barBonuses + ticketBonuses);
    },

    // set payment type from buy page
    [types.UPDATE_PROP_VALUE](state, data) {
      state[data.stateObject][data.stateObjectProp] = data.value;
    },

    // get sessionId from SocketIO and set it to `user` in `state`
    SOCKET_user_session_id(state, data) {
      state.user.sessionId = data.userSessionId;
      state.user.socketSessionId = data.socketSessionId;
    },

    // get sessionId from DB and set it to `user` & `cart` in `state`
    [types.RESTORE_USER_DATA](state, data) {
      state.user = data.user;
      state.user.sessionEndAt = null;
      state.cart = data.cart;
    },

    [types.SET_USER_DATA](state, data) {
      if (data) {
        state.user.card.number = data.publicId;
        state.user.name = data.profile.name;
        state.user.email = data.email;
        state.user.isAuthorized = true;
        state.user.createdAt = new Date(data.createdAt);
        state.user.birthday = data.profile.birthday;
        state.user.gender = data.profile.gender;
        state.user.phone = data.profile.phone;
        state.user.isRegistrationInWidget = data.isRegistrationInWidget;
      }
    },

    [types.SET_USER_BALANCE](state, data) {
      state.user.card.balance = Math.floor(data.balance);
      state.user.card.id = data.id;
    },

    [types.CALCULATE_USER_MAX_BONUSES](state) {
      let currentCartSum = state.cart.totalSum || state.cart.sum;
      let maxBonuses =
        state.user.card.balance < currentCartSum
          ? state.user.card.balance
          : currentCartSum;

      if (currentCartSum <= maxBonuses) {
        if (state.cart.bar.length) {
          maxBonuses -= 1;
        }

        if (state.cart.tickets.length) {
          maxBonuses -= 1;
        }
      }

      state.user.maxBonuses = maxBonuses;
    },
    [types.SET_ID_TOKEN](state, idToken) {
      state.idToken = idToken;
    },
    [types.SET_CUSTOMER_ACCOUNTS](state, accounts) {
      let map = {};
      let list = [];
      accounts.forEach((v) => {
        v.selected = false;
        v.picker = false;
        v.discount = {
          max: {
            all: 0,
            bar: 0,
            tickets: 0,
          },
          bar: 0,
          tickets: 0,
          value: 0,
        };
        v.changed = false;

        map[v.id] = v;
        list.push(v.id);
      });
      state.customer.accounts = map;
      state.customer.accountsList = list;
    },

    [types.SET_CUSTOMER_ACCOUNT](state, { accountId, data }) {
      const account = state.customer.accounts[accountId];

      state.customer.accounts[accountId] = merge(account, data);
    },

    [types.UNSELECT_CUSTOMER_ACCOUNTS](state) {
      state.customer.accountsList.forEach((accountId) => {
        state.customer.accounts[accountId].selected = false;
      });
    },

    [types.UNPICKED_CUSTOMER_ACCOUNTS](state) {
      state.customer.accountsList.forEach((accountId) => {
        state.customer.accounts[accountId].picker = false;
      });
    },
    [types.CUSTOMER_ACCOUNT_CALCULATE_BONUS_BALANCE](state, { accountId }) {
      // const account = state.customer.accounts[accountId];

      let availableTicketDiscount = state.cart.ticketSum - 1;
      // const availableBarDiscount = state.cart.barSum - 1;

      let account = state.customer.accounts[accountId];

      this.getters.selectedCustomerAccounts.forEach((account) => {
        if (account.id !== accountId) {
          availableTicketDiscount -= account.tickets;
          // availableBarDiscount -= account.bar;
        }
      });

      let calcTickets = Math.ceil(account.all / 2);
      let calcBar = account.all - calcTickets;

      if (calcTickets > availableTicketDiscount) {
        calcTickets = availableTicketDiscount;
        calcBar = account.all - availableTicketDiscount;
      }

      account.tickets = calcTickets;
      account.bar = calcBar;
    },

    // [types.SET_CUSTOMER_ACCOUNT_DISCOUNT_MAX](state, { accountId }) {
    //   state.customer.accounts[accountId].discount.max = this.getters.maxAvailableDiscountToAccount(accountId);
    // },
    // [types.SET_CUSTOMER_ACCOUNT_SELECTED](state, { accountId, value }) {
    //   state.customer.accounts[accountId].selected = value;
    // },
    [types.CALCULATE_CART](state) {
      console.log('CALCULATE_CART');

      const total = this.getters.total;
      state.cart.sum = total.all + state.cart.donations;
      state.cart.usedBonuses = total.discount.all;
      state.cart.spentBonuses = {
        bar: total.discount.bar,
        tickets: total.discount.tickets,
      };
    },
  },

  actions: {
    async loadApp(
      { commit, dispatch, state },
      { theatreId, session, idToken },
    ) {
      console.log('action: loadApp');

      commit(types.SET_ID_TOKEN, idToken);

      const user_session_id = state.user.sessionId;

      let dataUrl =
        setting.apiHost +
        `/v1/data/index?theatreId=${theatreId}&sessionId=${session}`;

      if (user_session_id) {
        dataUrl += `&user_session_id=${user_session_id}`;
      }

      const dataResponse = await axios(dataUrl);

      console.log('get: dataResponse');

      commit(types.SET_DATA, dataResponse.data);

      const placesResponse = await axios(
        setting.apiHost +
          `/v1/data/places?theatreId=${theatreId}&sessionId=${session}`,
      );

      console.log('get: placesResponse');

      commit(types.SET_PLACES, placesResponse.data);
      commit(types.SET_LOADING, false);

      dispatch('logUserConnect');

      return dataResponse;
    },

    // async loadPlaces({commit}, payload) {
    //   // commit(types.SET_LOADING, true);
    //   await axios(setting.apiHost + `/v1/data/places?theatreId=${payload.theatreId}&sessionId=${payload.session}`)
    //     .then(response => {
    //       commit(types.SET_PLACES, response.data);
    //       // commit(types.SET_LOADING, false);
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       throw error;
    //     });
    // },

    logApi(state, payload) {
      console.log('action: logApi');

      const user_session_id = this.state.user.sessionId;

      axios
        .post(
          setting.apiHost +
            `/v1/imprint/log?category=api&user_session_id=${user_session_id}`,
          {
            user: this.state.user,
            cart: this.state.cart,
            changes: payload.changes,
            status: payload.status,
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    logUser(state, payload) {
      console.log('action: logUser');
      const user_session_id = this.state.user.sessionId;

      axios
        .post(
          setting.apiHost +
            `/v1/imprint/log?category=user&user_session_id=${user_session_id}`,
          {
            user: this.state.user,
            cart: this.state.cart,
            changes: payload.changes,
            status: payload.status,
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    logUserConnect() {
      console.log('action: logUserConnect');

      const user_session_id = this.state.user.sessionId;

      axios
        .post(
          setting.apiHost +
            `/v1/imprint/log?category=user&user_session_id=${user_session_id}`,
          {
            user: this.state.user,
            cart: this.state.cart,
            changes: `Пользователь ID ${user_session_id} присоединился`,
            status: 'up',
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    logAddTicket({ commit }, payload) {
      console.log('action: logAddTicket');
      const user_session_id = this.state.user.sessionId;

      commit(types.ADD_PLACE_TO_CART, {
        place: payload.place,
      });

      axios
        .post(
          setting.apiHost +
            `/v1/imprint/log?category=ticket&user_session_id=${user_session_id}`,
          {
            user: this.state.user,
            cart: this.state.cart,
            changes: `Добавлено место: ID ${payload.place.id}, ряд ${payload.place.row}, место: ${payload.place.number}, стоимость: ${payload.place.price} руб.`,
            status: 'up',
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    logRemoveTicket({ commit }, payload) {
      console.log('action: logRemoveTicket');

      const user_session_id = this.state.user.sessionId;

      commit(types.REMOVE_PLACE_FROM_CART, payload.index);

      let place = payload.place;
      axios
        .post(
          setting.apiHost +
            `/v1/imprint/log?category=ticket&user_session_id=${user_session_id}`,
          {
            user: this.state.user,
            cart: this.state.cart,
            changes: `Удалено место: ID ${place.id}<br>Ряд ${place.row}<br>Место: ${place.number}<br>Cтоимость: ${place.price}`,
            status: 'down',
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    logApiTicketReserve(state, payload) {
      console.log('action: logApiTicketReserve');

      const user_session_id = this.state.user.sessionId;

      axios
        .post(
          setting.apiHost +
            `/v1/imprint/log?category=api-ticket-reserve&user_session_id=${user_session_id}`,
          {
            user: this.state.user,
            cart: this.state.cart,
            changes: payload.changes,
            status: payload.status,
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    logAddBarItem(state, payload) {
      console.log('action: logAddBarItem');

      const user_session_id = this.state.user.sessionId;

      axios
        .post(
          setting.apiHost +
            `/v1/imprint/log?category=bar&user_session_id=${user_session_id}`,
          {
            user: this.state.user,
            cart: this.state.cart,
            changes: `Добавлена позиция из бара "${payload.item.name}"<br>Стоимость: ${payload.item.price}`,
            status: 'up',
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    logRemoveBarItem(state, payload) {
      console.log('action: logRemoveBarItem');
      const user_session_id = this.state.user.sessionId;

      axios
        .post(
          setting.apiHost +
            `/v1/imprint/log?category=bar&user_session_id=${user_session_id}`,
          {
            user: this.state.user,
            cart: this.state.cart,
            changes: `Удалена позиция бара "${payload.item.name}" из корзины`,
            status: 'down',
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    logApiBarReserve(state, payload) {
      console.log('action: logApiBarReserve');

      const user_session_id = this.state.user.sessionId;

      axios
        .post(
          setting.apiHost +
            `/v1/imprint/log?category=api-bar-reserve&user_session_id=${user_session_id}`,
          {
            user: this.state.user,
            cart: this.state.cart,
            changes: payload.changes,
            status: payload.status,
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    logEquireing(state, payload) {
      console.log('action: logEquireing');

      const user_session_id = this.state.user.sessionId;

      axios
        .post(
          setting.apiHost +
            `/v1/imprint/log?category=equiring&user_session_id=${user_session_id}`,
          {
            user: this.state.user,
            cart: this.state.cart,
            changes: payload.changes,
            status: payload.status,
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    logRoute(state, payload) {
      console.log('action: logRoute');

      const user_session_id = this.state.user.sessionId;

      axios
        .post(
          setting.apiHost +
            `/v1/imprint/log?category=route&user_session_id=${user_session_id}`,
          {
            user: this.state.user,
            cart: this.state.cart,
            changes: payload.changes,
            status: payload.status,
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },

    async getUserByPaymentId({ commit }, payload) {
      console.log('action: getUserByPaymentId');

      // commit(types.SET_LOADING, true);

      let url = payload.paymentAttemptId
        ? `/v1/user/find-order?paymentAttemptId=${payload.paymentAttemptId}`
        : `/v1/user/find-order?orderId=${payload.orderId}`;
      let response = await axios.post(setting.apiHost + url).catch((error) => {
        console.log(error);
        throw error;
      });

      if (response.data.success === true) {
        // start timer at 15 mins
        commit(types.RESTORE_USER_DATA, {
          user: response.data.data.user,
          cart: response.data.data.cart,
        });
      } else {
        commit(types.ADD_ERROR, response.data.data);
      }

      console.log('action: getUserByPaymentId completed');
    },

    async reserveTicket({ commit }) {
      console.log('action: reserveTicket');

      commit(types.SET_LOADING, true);

      let tickets = this.state.cart.tickets;

      let response = await axios
        .post(
          setting.apiHost +
            `/v1/reserve/ticket?userSessionId=${this.state.user.sessionId}`,
          {
            Seats: tickets,
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });

      if (response.data.success === true) {
        // start timer at 15 mins
        if (response.data.data.Id) {
          commit(types.SET_TICKET_ORDER_ID, {
            ticketOrderId: response.data.data.Id,
            userSessionEndAt: response.data.data.userSessionEndAt,
          });

          this.dispatch('logApiTicketReserve', {
            changes: `Поставлен резерв (${this.state.user.ticketOrderId}) для выбранных в зале мест. <br>Переход на страницу бара.`,
            status: 'up',
          });
        }
      } else {
        commit(types.ADD_ERROR, response.data.data);

        this.dispatch('logApi', {
          changes: `Ошибка при резервировании билетов: ${response.data.data}`,
          status: 'down',
        });
      }

      commit(types.SET_LOADING, false);
    },

    async cancelReserveTicket({ commit }) {
      console.log('action: cancelReserveTicket');

      commit(types.SET_LOADING, true);

      let response = await axios
        .post(
          setting.apiHost +
            `/v1/reserve/cancel-ticket?userSessionId=${this.state.user.sessionId}`,
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });

      if (response.data.success === true) {
        this.dispatch('logApi', {
          changes: `${response.data.message}`,
          status: 'up',
        });
      } else {
        commit(types.ADD_ERROR, response.data.message);

        this.dispatch('logApi', {
          changes: `${response.data.message}`,
          status: 'down',
        });
      }

      commit(types.SET_LOADING, false);
    },

    async barReserve({ commit }) {
      console.log('action: barReserve');

      let response = await axios
        .post(
          setting.apiHost +
            `/v1/reserve/bar?userSessionId=${this.state.user.sessionId}`,
          {
            items: this.state.cart.bar,
          },
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });

      if (response.data.success === true) {
        // start timer at 15 mins
        // console.log(response.data.prepareOrderBefore);

        if (response.data.data.id) {
          commit(types.SET_BAR_ORDER_ID, {
            barOrderId: response.data.data.id,
            barOrderCode: response.data.data.code,
          });

          this.dispatch('logApiBarReserve', {
            changes: `Оформлен пред-заказ в баре. <br> Номер предзаказа: ${response.data.data.id}. <br>Код: ${response.data.data.code}`,
            status: 'up',
          });
        }
      } else {
        commit(types.ADD_ERROR, response.data);

        this.dispatch('logApi', {
          changes: `Ошибка при оформлении пред-заказа в баре: ${response.data.data}`,
          status: 'down',
        });
      }
    },

    async cancelBarReserve({ commit }) {
      console.log('action: cancelBarReserve');

      let response = await axios
        .post(
          setting.apiHost +
            `/v1/reserve/cancel-bar?userSessionId=${this.state.user.sessionId}`,
        )
        .catch((error) => {
          console.log(error);
          throw error;
        });

      if (response.data.success === true) {
        this.dispatch('logApiBarReserve', {
          changes: `Снят резерв бара ${this.state.user.barOrderId}`,
          status: 'down',
        });

        commit(types.SET_BAR_ORDER_ID, { barOrderId: null });
      } else {
        commit(types.ADD_ERROR, response.data);

        this.dispatch('logApi', {
          changes: `Ошибка при снятии резерва в баре: ${this.state.user.barOrderId}`,
          status: 'down',
        });
      }
    },

    // Send request to createOrder to backend
    async createOrder({ commit, getters }, payload) {
      console.log('action: createOrder');

      commit(types.SET_LOADING, true);

      let data = {
        user: this.state.user,
        cart: this.state.cart,
        theatre: this.state.theatre,
        session: this.state.session,
        theatreSessionId: payload.theatreSessionId,
      };

      let customerAccounts = [];
      getters.selectedCustomerAccounts.forEach((account) => {
        const { id, card_id, type, discount } = account;

        customerAccounts.push({
          id,
          type,
          card_id,
          discount: {
            bar: discount.bar,
            tickets: discount.tickets,
            value: discount.value,
          },
        });
      });

      // Нужно для начисления бонусов за покупку, если покупка проходит без траты бонусов
      // P.S. в самом виджете объект discount никак явно не вызывается в момент подтверждения заказа
      if (customerAccounts.length == 0) {
        getters.bonusCustomerAccount.forEach((account) => {
          const { id, card_id, type } = account;

          customerAccounts.push({
            id,
            type,
            card_id,
          });
        });
      }

      data.customerAccounts = customerAccounts;

      let response = await axios
        .post(
          setting.apiHost +
            `/v1/order/create?theatreId=${payload.theatreId}${
              payload.roistatVisit
                ? `&roistatVisit=${payload.roistatVisit}`
                : ''
            }`,
          data,
        )
        .catch((error) => {
          commit(types.SET_LOADING, false);
          // commit(types.ADD_ERROR, error);
          // throw error;
        });

      if (response.data.success === true) {
        let orderId = response.data.data;
        commit(types.SET_LOCAL_ORDER_ID, { orderId: orderId });

        this.dispatch('logApi', {
          changes: `Создан локальный заказ ${orderId}`,
          status: 'up',
        });
        if (this.state.cart.sum >= 0) {
          return this.dispatch('createPayment', {
            orderId: orderId,
            roistatVisit: payload.roistatVisit,
          });
        }
      } else {
        commit(types.SET_LOADING, false);
        commit(types.ADD_ERROR, response.data.errors);
        commit(types.CLEAR_ERRORS, 2000);

        this.dispatch('logApi', {
          changes: `Ошибка при создании заказа ${response.data.errors}`,
          status: 'down',
        });
      }
    },

    async createPayment({ commit }, payload) {
      console.log('action: createPayment');

      let response = await axios
        .post(setting.apiHost + `/v1/order/create-payment`, {
          orderId: payload.orderId,
          sum: this.state.cart.sum,
          userSessionId: this.state.user.sessionId,
          roistatVisit: payload.roistatVisit,
        })
        .catch((error) => {
          commit(types.ADD_ERROR, error.message);
          commit(types.CLEAR_ERRORS, 2000);

          console.log(error);
        });

      commit(types.SET_LOADING, false);

      if (response.data.success === true) {
        // start timer at 15 mins
        if (response.data.data) {
          if (response.data.data.transactionId) {
            commit(types.SET_TRANSACTION_ID, {
              transactionId: response.data.data.transactionId,
            });

            this.dispatch('logEquireing', {
              changes: `Для оплаты получен ID транзакции: ${response.data.data.transactionId}.<br>Пользователь перешел на страницу оплаты.`,
              status: 'up',
            });
          }
          window.location.href = response.data.data.url;
        }
      } else {
        commit(types.ADD_ERROR, response.data.data);
        commit(types.CLEAR_CART);
        commit(types.CLEAR_ERRORS, 2000);

        this.dispatch('logEquireing', {
          changes: `Ошибка при получении ID транзакции ${response.data.data}`,
          status: 'down',
        });

        throw 'error';
      }
    },

    async orderApprove({ commit }, payload) {
      console.log('action: orderApprove');

      let response = await axios
        .post(
          setting.apiHost +
            `/v1/order/approve?paymentAttemptId=${payload.paymentAttemptId}`,
        )
        .catch((error) => {
          throw error;
        });

      if (response.data.success === true) {
        // start timer at 15 mins
        if (response.data.data.ticket && response.data.data.bar) {
          this.dispatch('logApi', {
            changes: `Покупка прошла успешно. <br>Локальный номер заказа: <br>${response.data.data.localOrderId} <br>Номер заказа билетов: <br>${response.data.data.ticket.Id} <br>Номер заказа в баре: <br>${response.data.data.bar.id} <br>Код заказа в баре: <br>${response.data.data.bar.code}`,
            status: 'up',
          });
        }
      } else {
        if (response.data.data.ticket) {
          commit(types.ADD_ERROR, response.data.data.ticket);

          this.dispatch('logApi', {
            changes: `Ошибка при подтверждении бронирования билетов.<br> ${response.data.data.ticket}`,
            status: 'down',
          });
        }
        if (response.data.data.bar) {
          commit(types.ADD_ERROR, response.data.data.bar);

          this.dispatch('logApi', {
            changes: `Ошибка при подтверждении заказа в баре.<br> ${response.data.data.bar}`,
            status: 'down',
          });
        }
        commit(types.CLEAR_ERRORS, 4000);
      }
    },

    async fetchUserBalance({ commit, state }, payload) {
      console.log('action: fetchUserBalance');
      //debugger;
      if (state.setting.isBonusesAvailable) {
        let response = await axios
          .post(
            setting.apiHost + `/v1/user/get-user?apiKey=${payload.apiKey}`,
            {
              cardNumbers: payload.card,
              includeCards: 'true',
              includeAccounts: 'true',
            },
          )
          .catch((error) => {
            throw error;
          });

        if (response.data.success === true) {
          // if card exist
          if (response.data.data.id) {
            this.commit(types.SET_USER_BALANCE, response.data.data);
            this.dispatch('logUser', {
              changes: `Баланс пользователя получен. <br>Текущий баланс карты №${response.data.data.id}: <br>${response.data.data.balance}`,
              status: 'up',
            });
            this.commit(types.CALCULATE_USER_MAX_BONUSES);
          } else {
            this.dispatch('logUser', {
              changes: `У пользователя нет карты`,
              status: 'down',
            });
          }
        } else {
          commit(types.ADD_ERROR, response.data.data);
          this.dispatch('logUser', {
            changes: `Ошибка при получении бонусного баланса пользователя. <br>Карта: ${payload.card}`,
            status: 'down',
          });
        }
        commit(types.CLEAR_ERRORS, 4000);
      }
    },

    async fetchCustomerAccounts({
      commit,
      state: { widget_theatre_id, idToken },
    }) {
      console.log('action: fetchCustomerAccounts');
      if (widget_theatre_id && idToken) {
        const url =
          setting.apiHost +
          `/v1/user/accounts?theatreId=${widget_theatre_id}&idToken=${idToken}`;
        let accounts = await axios
          .get(url)
          .then((r) => r.data)
          .catch((error) => {
            throw error;
          });

        if (accounts) {
          commit(types.SET_CUSTOMER_ACCOUNTS, accounts);
          commit(types.CALCULATE_CART);
        }

        return accounts;
      } else {
        throw new Error(
          `invalid arguments fetchCustomerAccounts ${widget_theatre_id}, ${idToken}`,
        );
      }
    },
  },
});
